import React, { useEffect, useState } from 'react';
import ServiceElement from './ServiceElement';
import Modal from '../../../../components/modal/Modal';
import GridCellWrapper from '../../../../components/grid-cell-wrapper/GridCellWrapper';
import { connect } from 'react-redux';
import { setCurrentServices } from '../../../../redux/actions/auftragserfassung';
import InputFieldText from '../../../../components/input/floating-label/input-field/InputFieldText';

import { servicesComparator } from '../../../../utils/comparators';
import { ServiceModel } from '../../../../models/ServiceModel';
import {
  StateModel,
  StateModel_Auftragserfassung,
} from '../../../../redux/store';
import { AuftragDefaultServiceModel } from '../../../../models/AuftragDefaultServiceModel';
import {
  convertDynamicToServiceModel,
  ReplaceServiceModelBEXITY,
} from '../../../../redux/actions/defaultAuftragServices';
import { getServiceInitialListe } from './DefaultServices';
import { stringToUtcIsoDate } from '../../../../utils/date';
import { ConfigModel } from '../../../../models/ConfigModel';

interface ServicesProps {
  auftragserfassung: StateModel_Auftragserfassung;
  setCurrentServices: (services: ServiceModel[]) => void;
  customServices?: string;
  label: string;
  classes?: string;
  isKostenpfl: boolean;
  dynamicServices: AuftragDefaultServiceModel[];
  currentServices: ServiceModel[];
  config: ConfigModel;
}

const Services = (props: ServicesProps) => {
  const [services, setServices] = useState<ServiceModel[]>([]);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [modalEditService, setModalEditService] =
    useState<ServiceModel | null>();
  const [modalBezeichnung, setModalBezeichnung] = useState('');
  const [modalWert, setModalWert] = useState('');
  const [modalTyp, setModalTyp] = useState('');
  const [minId, setMinId] = useState(-1);
  let dynamicsAlreadySet = false;

  const reset = () => {
    const services = getServiceInitialListe(
      props.customServices,
      props.dynamicServices
    );
    props.setCurrentServices(services);

    dynamicsAlreadySet = true;
  };

  useEffect(() => {
    reset();
  }, [props.auftragserfassung.resetToggle]);

  useEffect(() => {
    setSpecificServices();
  }, [props.auftragserfassung.currentServices]);

  useEffect(() => {
    props.setCurrentServices(
      getServiceInitialListe(props.customServices, props.dynamicServices)
    );
    let tempCurrentServices = [...props.currentServices];

    tempCurrentServices.push(
      ...convertDynamicToServiceModel(props.dynamicServices)
    );

    tempCurrentServices = removeDuplicates(tempCurrentServices);

    props.setCurrentServices(tempCurrentServices);
  }, [props.dynamicServices]);

  const removeDuplicates = (services: ServiceModel[]): ServiceModel[] => {
    const temp = [...services];
    const ret: any[] = [];
    temp.forEach(service => {
      const i = ret.findIndex(e => e.spez_num === service.spez_num);
      if (i === -1) {
        ret.push(service);
      }
    });
    return ret;
  };

  /**
   * Fügt einen Services in die Services Liste hinzu.
   */
  const addService = () => {
    const tempList = [...props.auftragserfassung.currentServices];
    if (modalBezeichnung !== '') {
      // es wurde ein Name für den neuen Services angegeben
      tempList.push(createService());
      props.setCurrentServices(tempList);
    }
    handleClose();
  };

  /**
   * Erstellt einen neuen Services mit eindeutiger Element-ID
   */
  const createService = (): ServiceModel => {
    return {
      id: -1,
      elementId: createNewElementId(),
      bezeichnung: modalBezeichnung,
      wert: modalWert,
      //backgroundColor: 'bg-redA700',
      hinweis: true,
      active: true,
      editable: true,
      defaultService: false,
      attributName: '',
      isKostenpfl: props.isKostenpfl,
      spez_num: undefined,
      typ: undefined,
      isAWSperre: false,
    };
  };

  const setSpecificServices = () => {
    let tmp = props.auftragserfassung.currentServices;
    if (!props.auftragserfassung.id) {
      tmp = props.auftragserfassung.currentServices.filter(
        service => !service.isAWSperre
      );
    }
    if (props.config.clientKunde?.toLowerCase() === 'bexity') {
      ReplaceServiceModelBEXITY(tmp);
    }
    if (props.isKostenpfl) {
      setServices(
        //props.auftragserfassung.currentServices.filter(
        tmp.filter(service => service.isKostenpfl)
      );
    } else {
      setServices(
        /* props.auftragserfassung.currentServices.filter(
          service => !service.isKostenpfl */
        tmp.filter(service => !service.isKostenpfl)
      );
    }
  };

  /**
   * Erstellt eine neue Element-ID im negativ-Bereich,
   * um die tatsächlichen IDs von bspw. Services nicht zu überschneiden
   */
  const createNewElementId = () => {
    const newId = minId - 1;
    setMinId(newId);
    return newId;
  };

  /**
   * Steuert die Schließung vom Modalen Fenster und leert den State der Felder.
   */
  const handleClose = () => {
    setShowModalEdit(false);
    setModalEditService(null);
    setModalBezeichnung('');
    setModalWert('');
  };

  const sortServices = (list: ServiceModel[]) => {
    let tmpList = [...list];
    tmpList = tmpList.sort(servicesComparator);
    return tmpList;
  };

  /**
   * Aktualisiert das Attribut Active im State des Services auf den Wert aus dem gelieferten Services.
   * Wird ein editierbarer default-Services aktiviert, der noch keinen Wert hat, wird das Modulare Editierfenster geöffnet.
   *
   * @param service
   */
  const setActive = (service: ServiceModel) => {
    const tempList = [...props.auftragserfassung.currentServices];
    const index = tempList.findIndex(bes => bes.elementId == service.elementId);

    tempList[index].active = service.active;

    //Für editierbaren Default-Services direkt modalEdit öffnen
    if (service.editable && service.active && !service.wert) {
      showEditService(service);
    } else {
      props.setCurrentServices(tempList);
    }
  };

  /**
   * Aktualisiert die Attribute 'Bezeichnung' und 'Wert' im State des Services auf die Werte aus dem geliefertem Services.
   *
   * @param service
   */
  const editService = (service: ServiceModel) => {
    const tempList = [...props.auftragserfassung.currentServices];
    const index = tempList.findIndex(bes => bes.elementId == service.elementId);
    tempList[index].bezeichnung = modalBezeichnung;
    tempList[index].wert = modalWert;
    tempList[index].active = modalWert != '';

    props.setCurrentServices(tempList);

    handleClose();
  };

  /**
   * Sorgt für die Anzeige eines Modalen Fensters zum Anlegen und editieren eines Services.
   *
   * @param service
   */
  const showEditService = (service: ServiceModel) => {
    setModalEditService(service);

    let wertuebergabe = service.wert;
    if (service.typ?.toLowerCase() === 'datum') {
      if (service.wert != undefined && service.wert.trim().length > 0) {
        wertuebergabe = stringToUtcIsoDate(service.wert);
      }
    }

    if (service.bezeichnung) setModalBezeichnung(service.bezeichnung);
    if (service.wert) setModalWert(wertuebergabe);
    if (service.typ) setModalTyp(service.typ);
    setShowModalEdit(true);
  };

  const getInputType = (typ: string | undefined) => {
    switch (typ) {
      case 'Datum':
        return 'datetime-local';
        break;
      case 'Integer':
      case 'Dezimal':
        return 'number';
        break;
      case undefined:
      default:
        return 'text';
    }
  };

  /**
   * Liefert das Modal-Element zum Anlegen und Bearbeiten eines Services
   */
  const getModalEditComponent = (): JSX.Element => {
    return (
      <Modal
        show={showModalEdit}
        closeHandler={handleClose}
        titel={
          showModalEdit && modalEditService
            ? `${modalEditService.bezeichnung} bearbeiten`
            : 'Service hinzufügen'
        }
      >
        <div className='modal-body-wrapper'>
          {modalEditService && modalEditService.defaultService ? (
            ''
          ) : (
            <InputFieldText
              label='Titel'
              onChangeHandler={setModalBezeichnung}
              value={modalBezeichnung}
            />
          )}
          <InputFieldText
            label='Beschreibung'
            onChangeHandler={setModalWert}
            value={modalWert}
            inputType={getInputType(modalTyp)}
          />
          <br />
          <div className='modal-btn-group'>
            <button
              className={
                !modalBezeichnung.trim()
                  ? 'modal-btn modal-btn-disabled'
                  : 'modal-btn'
              }
              disabled={!modalBezeichnung.trim()}
              onClick={
                showModalEdit && modalEditService
                  ? () => editService(modalEditService)
                  : () => addService()
              }
            >
              Bestätigen
            </button>
            <button className='modal-btn' onClick={handleClose}>
              Abbrechen
            </button>
          </div>
        </div>
      </Modal>
    );
  };

  return (
    <GridCellWrapper
      classes={`${props.classes} noSelect`}
      label={props.label}
      saveUserAnsicht={() => {
        null;
      }}
    >
      <ul>
        {services.map((service, index: number) => (
          <ServiceElement
            key={index}
            service={service}
            setActive={setActive}
            editService={showEditService}
          />
        ))}
      </ul>

      {getModalEditComponent()}
    </GridCellWrapper>
  );
};

const mapStateToProps = (state: StateModel) => ({
  auftragserfassung: state.Auftragserfassung,
  customServices: state.Config.customServices,
  dynamicServices: state.Stammdaten.dynamicServices,
  currentServices: state.Auftragserfassung.currentServices,
  config: state.Config,
});

export default connect(mapStateToProps, {
  setCurrentServices,
})(Services);
